<template>
  <div class="manage-tracker-geofence-map">
    <live-stage-map
      ref="map"
      class="card mb-3"
      :stage-routes="stageRoutes"
      :stage-waypoints="stageWaypoints"
      :tracker-geofences="trackerGeofences"
      :route-opacity="0.5"
      @click="$emit('update:selectedGeofence', null)"
      @selectGeofence="$emit('select', { ...$event })"
    >
      <o-map-editable-circle-marker
        v-if="tmpGeofence"
        label="En cour de création"
        fill-color="orange"
        stroke-color="orange"
        :stroke-weight="8"
        :radius="tmpGeofence.radius"
        :location="tmpGeofence.location"
        :min-radius="50"
        @update:radius="$emit('update:tmpGeofence', { ...tmpGeofence, radius: $event })"
        @update:location="$emit('update:tmpGeofence', { ...tmpGeofence, location: $event })"
      />

      <!-- Preview selected geofence temporary changes -->
      <o-map-editable-circle-marker
        v-if="selectedGeofence"
        label="En cour de d'édition"
        :fill-color="selectedGeofenceColor"
        :stroke-color="selectedGeofenceColor"
        :stroke-weight="8"
        :radius="selectedGeofence.radius"
        :location="selectedGeofence.location"
        :min-radius="50"
        @update:radius="$emit('update:selectedGeofence', { ...selectedGeofence, radius: $event })"
        @update:location="
          $emit('update:selectedGeofence', { ...selectedGeofence, location: $event })
        "
      />
    </live-stage-map>

    <div class="manage-tracker-geofence-map_action">
      <b-button v-if="tmpGeofence" type="is-danger" @click="$emit('update:tmpGeofence', null)">
        Annuler
      </b-button>
      <template v-else-if="selectedGeofence">
        <b-button type="is-primary" :disabled="loading" :loading="loading" @click="update">
          Modifier
        </b-button>
        <b-button type="is-danger" @click="$emit('update:selectedGeofence', null)">
          Annuler
        </b-button>
      </template>
      <b-button
        v-else
        type="is-success"
        icon-left="plus"
        :disabled="!enableCreation || tmpGeofence"
        @click="createTmpGeofence"
      >
        {{ createButtonLabel }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OMapEditableCircleMarker from '@components/Map/MapEditableCircleMarker.vue'
import LiveStageMap from '@views/MapView/LiveStageMap.vue'
import { TRACKER_INTERVAL_COLORS } from '@constants/tracker/interval'

export default {
  name: 'Map',

  components: {
    LiveStageMap,
    OMapEditableCircleMarker,
  },

  props: {
    tmpGeofence: {
      type: Object,
      default: null,
    },
    selectedGeofence: {
      type: Object,
      default: null,
    },
    stageRoutes: {
      type: Object,
      required: true,
    },
    stageWaypoints: {
      type: Array,
      required: true,
    },
    trackerGeofences: {
      type: Array,
      required: true,
    },
    enableCreation: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    createButtonLabel() {
      if (this.enableCreation && !this.tmpGeofence) {
        return 'Ajouter Geofence'
      }

      return this.enableCreation ? 'Création en cours' : `Limite atteinte`
    },

    selectedGeofenceColor() {
      return this.selectedGeofence
        ? TRACKER_INTERVAL_COLORS[this.selectedGeofence.inTrackerInterval]
        : null
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    createTmpGeofence() {
      if (!this.enableCreation) {
        return
      }

      // Disabled edition
      this.$emit('update:selectedGeofence', null)

      const center = this.$refs.map.getCenter()

      this.$emit('update:tmpGeofence', {
        location: [center.lat, center.lng],
        radius: 500,
      })
    },

    async update() {
      this.loading = true

      try {
        const liveStageGeofence = await this.$services.liveTrackerGeofenceService.update({
          ...this.selectedGeofence,
          location: {
            latitude: this.selectedGeofence.location[0],
            longitude: this.selectedGeofence.location[1],
          },
        })

        this.$emit('update', liveStageGeofence)

        this.addToastMessage({
          text: `Le geofence "${liveStageGeofence.name}" a été modifié.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? `La modification du geofence ${this.geofence.name} a échouée.`,
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss">
@import 'variables';

.manage-tracker-geofence-map {
  position: relative;

  &_action {
    position: absolute;
    bottom: $spacing-s;
    left: $spacing-s;
  }
}
</style>
